import Background from '../../views/setting/background/Index'
import List from '../../views/setting/background/List'
import Create from '../../views/setting/background/Create'
import Edit from '../../views/setting/background/Edit'
import Show from '../../views/setting/background/Show'
import Permissions from '@/permissions'

export const backgroundRouters = {
  path: 'background',
  component: Background,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.setting.background.manage],
    groups: 'background'
  },
  children: [
    {
      path: '',
      name: 'list-background',
      component: List,
      meta: {
        permissions: [
          Permissions.backend.setting.background.list,
          Permissions.backend.setting.whyUsImage.list
        ],
        groups: 'background',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Background',
            name_km: 'ផ្ទាំងរូបភាព'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'create',
      name: 'create-background',
      component: Create,
      meta: {
        permissions: [
          Permissions.backend.setting.background.store
        ],
        groups: 'background',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Background',
            name_km: 'ផ្ទាំងរូបភាព'
          },
          {
            name_en: 'Create',
            name_km: 'បង្កើត'
          }
        ]
      }
    },
    {
      path: 'edit/:uuid',
      name: 'edit-background',
      component: Edit,
      meta: {
        permissions: [
          Permissions.backend.setting.background.edit
        ],
        groups: 'background',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Background',
            name_km: 'ផ្ទាំងរូបភាព'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'show/:uuid',
      name: 'show-background',
      component: Show,
      meta: {
        permissions: [
          Permissions.backend.setting.background.show
        ],
        groups: 'background',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Background',
            name_km: 'ផ្ទាំងរូបភាព'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
